// extracted by mini-css-extract-plugin
export default {"poweredByKorraWrapper":"poweredByKorraWrapper__XXegb","poweredByKorra":"poweredByKorra__qMlQ-","topKorraA":"topKorraA__G24qq"};